// The choices the filter panel offers, with their labels in both languages.
// The panel (components/filters/FilterSections.tsx) and the chips of applied
// filters above the results (lib/filter-chips.ts) read them from here, so a
// filter is named the same way where it is set and where it is shown.

export const HEATING_TYPES = [
  { id: '', en: 'Any Heating', fr: 'Tout chauffage' },
  { id: 'Forced Air Gas', en: 'Forced Air Gas', fr: 'Gaz à air pulsé' },
  { id: 'Electric Baseboard', en: 'Electric', fr: 'Électrique' },
  { id: 'Geothermal Heat Pump', en: 'Geothermal', fr: 'Géothermie' },
  { id: 'Hot Water Radiators', en: 'Radiators', fr: 'Radiateurs d\'eau' },
] as const;

export const BASEMENT_STATUSES = [
  { id: '', en: 'Any Basement', fr: 'Tout sous-sol' },
  { id: 'Finished', en: 'Finished', fr: 'Aménagé' },
  { id: 'Unfinished', en: 'Unfinished', fr: 'Non aménagé' },
  { id: 'Partially Finished', en: 'Partially Finished', fr: 'Partiellement' },
  { id: 'None (Slab)', en: 'None', fr: 'Aucun (Dalle)' },
] as const;

export const AMENITIES = [
  { id: 'pool', en: 'Pool', fr: 'Piscine' },
  { id: 'gym', en: 'Gym', fr: 'Salle de sport' },
  { id: 'balcony', en: 'Balcony', fr: 'Balcon' },
  { id: 'fireplace', en: 'Fireplace', fr: 'Foyer' },
  { id: 'waterfront', en: 'Waterfront', fr: 'Bord de l\'eau' },
  { id: 'rooftop', en: 'Rooftop', fr: 'Terrasse toit' },
  { id: 'ev_charging', en: 'EV Charger', fr: 'Borne de recharge VE' },
  { id: 'smart_home', en: 'Smart Home', fr: 'Maison intelligente' },
] as const;

/** The quick-filter tags a search can carry (?tag=...). */
export const TAGS = [
  { id: 'house', en: 'Houses', fr: 'Maisons' },
  { id: 'condo', en: 'Condos', fr: 'Condos' },
  { id: 'new_listings', en: 'New this week', fr: 'Nouveautés de la semaine' },
  { id: 'price_reduced', en: 'Price reduced', fr: 'Prix réduit' },
  { id: 'luxury', en: 'Luxury ($1M+)', fr: 'Prestige (1 M$+)' },
  { id: 'waterfront', en: 'Waterfront', fr: 'Bord de l\'eau' },
  { id: 'low_condo_fees', en: 'Low condo fees', fr: 'Frais de copropriété bas' },
  { id: 'with_garage', en: 'With garage', fr: 'Avec garage' },
] as const;

export function optionLabel(list: ReadonlyArray<{ id: string; en: string; fr: string }>, id: string, lang: string): string {
  const entry = list.find((o) => o.id === id);
  if (!entry) return id;
  return lang === 'fr' ? entry.fr : entry.en;
}
